import NotificationSiteMetaLine from "./NotificationSiteMetaLine";

const NotificationCampaignContext = ({ takenLine, wasteName, addressName }) => {
  const hasSiteMeta = Boolean(wasteName || addressName);

  if (!takenLine && !hasSiteMeta) {
    return null;
  }

  return (
    <div className="notification-campaign-context">
      {takenLine && (
        <p className="notification-campaign-context-time">{takenLine}</p>
      )}
      <NotificationSiteMetaLine
        wasteName={wasteName}
        addressName={addressName}
        className="notification-campaign-context-site notification-site-meta"
      />
    </div>
  );
};

export default NotificationCampaignContext;
